export type SnippetsDictionary = {
  [environment: string]: string;
};

// Referência: https://developers.google.com/tag-platform/tag-manager/web/datalayer#installation
export const dataLayerSnippet = (): string => 'window.dataLayer = window.dataLayer || []';

export const GTMSnippetByEnvironment = (gtmId: string, environment: string): string => {
  const snippetsByEnvironment: SnippetsDictionary = {
    hmg: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', '${gtmId}');`,

    prd: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');`,

    default: '',
  };

  return snippetsByEnvironment[environment] || snippetsByEnvironment.default;
};

export const GTMIframeSnippetByEnvironment = (gtmId: string, environment: string): string => {
  const iframeSnippetsByEnvironment: SnippetsDictionary = {
    hmg: `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`,

    prd: `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`,

    default: '',
  };

  return iframeSnippetsByEnvironment[environment] || iframeSnippetsByEnvironment.default;
};
